module.exports = __webpack_public_path__ + "static/img/img2-8.8b17ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img2-8.jpg
// module id = g8uI
// module chunks = 0